import React from 'react';
import { connect } from 'react-redux';
import { State } from 'app/gamma/src/modules';
import { getMyTeams } from 'app/gamma/src/selectors/teams';
import {
  Tab,
  TabLink,
  TabIcon,
  TabLogo,
  TabText,
  TabList,
  TabButtonProps,
} from './tab';
import { TeamModel } from 'app/gamma/src/types/models';
import { TeamTabProps, TeamLinkSubTab } from './team-tab';
import { HomeTestIds } from '@trello/webdriverio-tests';
import { CreateTeamButton } from './create-team-button';
import { SectionHeader } from './section-header';
import styles from './team-list.less';

import { forTemplate } from 'app/common/lib/util/i18n';
const l = forTemplate('home');

interface TeamTabListProps {
  teamTabs: TeamTabProps[];
  createTeamButton: TabButtonProps;
}

interface TeamTabListStateProps {
  teams: TeamModel[];
}

interface TeamTabListDispatchProps {}

type AllTeamTabListProps = TeamTabListProps &
  TeamTabListStateProps &
  TeamTabListDispatchProps;

const TeamTab: React.FunctionComponent<TeamTabProps> = ({
  displayName,
  expanded,
  orgId,
  linkTabs,
  logoUrl1x,
  logoUrl2x,
  selected,
  ...props
}) => (
  <Tab data-test-id={`${HomeTestIds.TeamTabSection}${orgId}`}>
    <TabLink selected={selected} {...props}>
      {logoUrl1x && <TabLogo logoUrl1x={logoUrl1x} logoUrl2x={logoUrl2x} />}
      {!logoUrl1x && <TabIcon iconName="organization" />}
      <TabText data-test-id={HomeTestIds.TeamTabName}>{displayName}</TabText>
    </TabLink>
    {expanded &&
      !!linkTabs.length && (
        <TabList>
          {linkTabs.map((linkTab) => <TeamLinkSubTab {...linkTab} />)}
        </TabList>
      )}
  </Tab>
);

const TeamTabListUnconntected: React.FunctionComponent<AllTeamTabListProps> = ({
  teamTabs,
  teams,
  createTeamButton,
}) => (
  <TabList>
    <div className={styles.sectionHeaderWrapper}>
      <SectionHeader noMargin>{l('teams')}</SectionHeader>
      {teams.length > 0 && <CreateTeamButton {...createTeamButton} />}
    </div>
    {teamTabs.map((teamTab) => <TeamTab {...teamTab} />)}
    {teams.length === 0 && (
      <Tab>
        <CreateTeamButton fullTab {...createTeamButton} />
      </Tab>
    )}
  </TabList>
);

const mapStateToProps = (state: State): TeamTabListStateProps => ({
  teams: getMyTeams(state),
});

export const TeamTabList = connect(mapStateToProps)(TeamTabListUnconntected);
